import { PortalSettingsStoreType, VehicleParametersExceedeFilterMode, VehicleWeightLimitFilterMode } from "./types";

export const initialState: PortalSettingsStoreType = {
    weightLimitFilterMode: VehicleWeightLimitFilterMode.All,
    parametersExceededFilterMode: VehicleParametersExceedeFilterMode.All
};